import { getTeamColor } from './get-team-color';

interface OrgTeamLike {
  teamId?: number | null;
  name?: string | null;
}

export type DecoratedOrgTeam<T extends OrgTeamLike = OrgTeamLike> = T & { color: string };

// Color is assigned by PRE-SORT fetch order - preserve when refactoring.
export function decorateOrgTeams<T extends OrgTeamLike>(teams: T[]): DecoratedOrgTeam<T>[] {
  return teams
    .map((team, index) => ({
      ...team,
      color: getTeamColor(index),
    }))
    .sort((a, b) => {
      if (a.name && b.name) {
        return a.name.localeCompare(b.name);
      }
      return 0;
    });
}
